<script>
import { authComputed } from '@/state/helpers'
import moment from 'moment'

export default {
  computed: {
    ...authComputed,
    greeting () {
      const morning = 6
      const afternoon = 12
      const evening = 18
      const night = 23

      const currentHour = parseFloat(moment().format('HH'))

      if (currentHour < morning || currentHour >= night) return 'night'
      if (currentHour >= morning && currentHour < afternoon) return 'morning'
      if (currentHour >= afternoon && currentHour < evening) return 'afternoon'
      if (currentHour >= evening && currentHour < night) return 'evening'
      return 'morning'
    }
  }
}
</script>
<template>
  <div class="portal-welcome">
    <h4 class="mb-1 portal-welcome__title">
      {{ $t(`dashboard.welcome.${greeting}`) }}
      {{ userProfile.firstname }}!
    </h4>
    <p class="m-0 text-muted" v-if="userRole === 'user'">
      {{ $t('dashboard.welcome.message') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.portal-welcome {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  padding: 1.15rem 1.35rem;

  &__title {
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.02em;
  }
}
</style>
